const ServicosRotas = [
    {
        path: '/gescon/fornecedores/servicos',
        name: 'Gescon_Fornecedores_Servicos_Listagem',
        component: () => import('./Servicos.vue'),
        meta: { title: 'Serviços - GESCON' }
    },
    {
        path: '/gescon/fornecedores/servicos/:comprometimentoId',
        name: 'Gescon_Fornecedores_Servicos_Detalhar',
        component: () => import('./ServicoDetalhar.vue'),
        meta: { title: 'Detalhar Serviço - GESCON' }
    }
]

export default ServicosRotas